.Body {
  background: var(--grey);
  color: var(--white);
  width: 100vw;
  margin: 0;
  overflow-x: hidden;
  font-family: var(--main-font), sans-serif;
  font-size: var(--text-xs);
  opacity: 0;
  line-height: 1.2;

  ::selection {
    background: #a1a1a1;
    color: white;
  }
}

.Visible {
  opacity: 1;
}
